module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00019.5ade1d38.png";